module.exports = __webpack_public_path__ + "img/work-from-home.bf22eeef.svg";